import { CloudOff } from "lucide-react";

export function PendingBadge({ testid }) {
  return (
    <span className="ml-2 inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-bold text-amber-800" data-testid={testid}>
      <CloudOff className="h-3 w-3" /> Waiting to sync
    </span>
  );
}
